var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "flex center-xs space-bottom-1 space-top-1" },
    [
      _c("div", { staticClass: "flex vertical-center align-center" }, [
        _c("div", [
          _vm.inputValid
            ? _c("input", {
                staticClass: "form-button",
                attrs: { type: "button", value: _vm.buttonText },
                on: {
                  click: function ($event) {
                    return _vm.$emit("progress")
                  },
                },
              })
            : _c("input", {
                staticClass: "form-button",
                attrs: { type: "button", value: _vm.buttonText, disabled: "" },
              }),
        ]),
        _vm._v(" "),
        _vm.order !== "first"
          ? _c("div", [
              _c("input", {
                staticClass: "back-button",
                attrs: { type: "button", value: _vm.backButtonText },
                on: {
                  click: function ($event) {
                    return _vm.$emit("back")
                  },
                },
              }),
            ])
          : _vm._e(),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }